export const SERVICE_LIST_REQUEST = "SERVICE_LIST_REQUEST";
export const SERVICE_LIST_SUCCESS = "SERVICE_LIST_SUCCESS";
export const SERVICE_LIST_FAIL = "SERVICE_LIST_FAIL";
export const SERVICE_LIST_RESET = "SERVICE_LIST_RESET";

export const POST_SERVICE_REQUEST = "POST_SERVICE_REQUEST";
export const POST_SERVICE_SUCCESS = "POST_SERVICE_SUCCESS";
export const POST_SERVICE_FAIL = "POST_SERVICE_FAIL";
export const POST_SERVICE_RESET = "POST_SERVICE_RESET";

export const UPDATE_SERVICE_REQUEST = "UPDATE_SERVICE_REQUEST";
export const UPDATE_SERVICE_SUCCESS = "UPDATE_SERVICE_SUCCESS";
export const UPDATE_SERVICE_FAIL = "UPDATE_SERVICE_FAIL";
export const UPDATE_SERVICE_RESET = "UPDATE_SERVICE_RESET";

export const DELETE_SERVICE_REQUEST = "DELETE_SERVICE_REQUEST";
export const DELETE_SERVICE_SUCCESS = "DELETE_SERVICE_SUCCESS";
export const DELETE_SERVICE_FAIL = "DELETE_SERVICE_FAIL";
export const DELETE_SERVICE_RESET = "DELETE_SERVICE_RESET";
